import React from 'react'
import { useTranslation } from 'react-i18next'

import { Button } from 'components'
import { CreateTicketForm } from '../CreateTicketForm/CreateTicketForm'
import { TicketProductTable } from 'types'

interface CreateTicketFormSectionProps {
  baseClass: string
  isLoadingBtn: boolean
  products: TicketProductTable[]
}

export const CreateTicketFormSection: React.FC<CreateTicketFormSectionProps> = (
  props,
) => {
  const { baseClass, isLoadingBtn, products } = props
  const isNoProduct = !products.length

  const { t } = useTranslation(['ticket'])

  return (
    <div className={`${baseClass}__wrap-form-create`}>
      <CreateTicketForm isNoProduct={isNoProduct} />

      <Button
        disabled={isNoProduct}
        className={`${baseClass}__submit-btn`}
        type='submit'
        isLoading={isLoadingBtn}
      >
        {t('ticket:add.button')}
      </Button>
    </div>
  )
}
